export const placeholders = {
  es: {
    riskProfileQuestion: "Seleccioná una opción",
  },

  en: {
    riskProfileQuestion: "Select an option",
  },
};

export const title = {
  es: "Perfil inversor",
  en: "Investor profile",
};
